import { render, staticRenderFns } from "./DailyReportAssignmentCardFieldLabels.vue?vue&type=template&id=ec5707c4&"
import script from "./DailyReportAssignmentCardFieldLabels.vue?vue&type=script&lang=js&"
export * from "./DailyReportAssignmentCardFieldLabels.vue?vue&type=script&lang=js&"
import style0 from "./DailyReportAssignmentCardFieldLabels.vue?vue&type=style&index=0&id=ec5707c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports